
import MainSubtitleContext from "@/services/subtitle/contexts/MainSubtitleContext";
import ShareSubtitleContext from "@/services/subtitle/contexts/ShareSubtitleContext";

class SubtitleService {
    extensions = [".vtt", ".srt", ".smi"];

    getContext(mediaFile) {
        return mediaFile?.isShared
            ? ShareSubtitleContext
            : MainSubtitleContext;
    }

    async request(file, sync = 0, mediaFile) {
        if (!file || typeof file !== "string") {
            return false;
        }

        const context = this.getContext(mediaFile);

        return await context.request(file, sync, mediaFile);
    }

    async find(file, sync = 0, mediaFile) {
        if (!file || typeof file !== "string") {
            return false;
        }

        const baseName = file.replace(/\.[^/.]+$/, "");

        for (const ext of this.extensions) {
            const result = await this.request(
                `${baseName}${ext}`,
                sync,
                mediaFile
            );

            if (result) {
                return result;
            }
        }

        return false;
    }

    async get(file, sync = 0, mediaFile) {
        return await this.request(file, sync, mediaFile);
    }
}

export default new SubtitleService();
